var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "userInfo-wrapper"
  }, [_c("a-row", {
    attrs: {
      gutter: 16
    }
  }, [_c("a-col", {
    attrs: {
      span: 7
    }
  }, [_c("a-card", {
    attrs: {
      hoverable: true,
      bordered: false
    }
  }, [_c("div", {
    staticClass: "accountInfo"
  }, [_c("img", {
    staticClass: "accountImg",
    attrs: {
      src: require("../../../assets/nav/user.gif"),
      alt: ""
    }
  }), _c("div", {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.accountInfo.username))]), _c("div", {
    staticClass: "userRole"
  }, [_vm._v(_vm._s(_vm.accountInfo.role))])]), _c("div", {
    staticClass: "accountMajor"
  }, [_vm._l(_vm.accountInfo, function (v, k) {
    return [k != "username" && k != "role" ? _c("div", {
      key: k,
      staticClass: "major-wrapper"
    }, [_c("svg-icon", {
      staticClass: "vertical-bottom",
      attrs: {
        icon: k
      }
    }), _c("span", {
      staticClass: "major-name"
    }, [_vm._v(_vm._s(v))])], 1) : _vm._e()];
  })], 2), _c("a-divider"), _c("div", {
    staticClass: "tabList"
  }, [_c("p", [_vm._v("标签")]), _vm._l(_vm.tagList, function (item) {
    return [_c("a-tag", {
      key: item.title,
      staticStyle: {
        "margin-bottom": "6px"
      },
      attrs: {
        closable: "",
        color: item.color
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")])];
  }), _vm.addInputShow ? _c("a-input", {
    ref: "input",
    style: {
      width: "78px"
    },
    attrs: {
      type: "text",
      size: "small"
    },
    on: {
      blur: _vm.inputConfirm,
      keyup: function ($event) {
        if (!$event.type.indexOf("key") && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.inputConfirm.apply(null, arguments);
      }
    },
    model: {
      value: _vm.tagValue,
      callback: function ($$v) {
        _vm.tagValue = $$v;
      },
      expression: "tagValue"
    }
  }) : _c("a-tag", {
    staticStyle: {
      cursor: "pointer"
    },
    on: {
      click: _vm.writeInput
    }
  }, [_c("a-icon", {
    attrs: {
      type: "plus"
    }
  }), _vm._v(" New Tag ")], 1)], 2), _c("a-divider"), _c("div", {
    staticClass: "skillList"
  }, [_c("p", [_vm._v("技能")]), _vm._l(_vm.skillList, function (item) {
    return _c("div", {
      key: item.title,
      staticClass: "skill-wrapper"
    }, [_vm._v(" " + _vm._s(item.title) + " "), _c("a-progress", {
      attrs: {
        percent: item.value,
        status: item.status
      }
    })], 1);
  })], 2)], 1)], 1), _c("a-col", {
    attrs: {
      span: 17
    }
  }, [_c("a-card", {
    attrs: {
      bordered: false,
      "tab-list": _vm.tabList,
      "active-tab-key": _vm.currentKey
    },
    on: {
      tabChange: _vm.changeTab
    }
  }, [_c(_vm.currentKey, {
    tag: "component"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };